import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpHelper {

  constructor(private readonly http: HttpClient) {

  }
  public get(url: string, onSuccess, onError): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get<any>(url, httpOptions)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))
  }

  public post(url: string, item: any, onSuccess, onError): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      })
    };

    return this.http.post<any>(url, item, httpOptions)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))

  }

  public put(url: string, item: any, onSuccess, onError): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      })
    };

    return this.http.put<any>(url, item, httpOptions)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))

  }

  public patch(url: string, item: any, onSuccess, onError): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      })
    };

    return this.http.patch<any>(url, item, httpOptions)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))

  }

  public delete(url: string, onSuccess, onError): Observable<any> {

    return this.http.delete<any>(url)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))
  }
}
